import {GlobalConstants} from "../data/GlobalConstants";
import {handleResponse} from "../util/functions";
import {getToken} from "../helpers/helperJWT";
import {loaderService} from "./loaderService";

const url = GlobalConstants.urlApi;

export const adminService = {
    getMenusByUser,
    getPerfiles,
    getPerfileById,
    setCrearPerfil,
    setEditarPerfil,
    setEliminarPerfil,
    getAllUsers,
    getUserById,
    getMenusByRol,
    setStateUsuariosById,
    setUsuariosCrud,
    SetUpdatePasswordUsuario,
    getAllMenus,
    setCrudMenu
};


function getMenusByUser(user) {

    loaderService.showLoader({label: "Cargando..."});


   const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({ user, idApp: 1 })
    };

    return fetch(`${url}/menu/getMenuCore`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getPerfiles() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/admin/getAllProfiles`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getPerfileById(perfil) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({perfil})
    };

    return fetch(`${url}/admin/getProfileById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setCrearPerfil(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/admin/createPerfil`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setEditarPerfil(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/admin/updatePerfil`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setEliminarPerfil(perfil) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({perfil})
    };

    return fetch(`${url}/admin/deletePerfil`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getAllUsers() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/admin/getAllUsers`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setStateUsuariosById(params) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(params)
    };

    return fetch(`${url}/admin/setStateUsuariosById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });

}

function getUserById(usr) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({usr})
    };

    return fetch(`${url}/admin/getUserId`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });

}

function getMenusByRol(rol) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({rol})
    };

    return fetch(`${url}/admin/getMenusByRol`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });

}

function setUsuariosCrud(datos) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({datos})
    };

    return fetch(`${url}/admin/crudUsuarios`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });

}

function SetUpdatePasswordUsuario(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/admin/updatePasswordUsuario`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });

}

function getAllMenus(idApp) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({idApp})
    };

    return fetch(`${url}/menu/getMenuByAdmin`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });

}

function setCrudMenu(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/menu/crudMenu`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });

}

